import { Button, Icon } from "@material-ui/core";
import styled from "styled-components";

export default function Office365Button({ children, onClick }) {
  return (
    <Button
      color="primary"
      data-testid="landing__office365-btn"
      disableElevation
      fullWidth
      size="large"
      variant="contained"
      startIcon={
        <OfficeLogo style={{ fontSize: "16px" }} className="icon-windows8" />
      }
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

const OfficeLogo = styled(Icon)`
  margin-right: 11px;
`;
